import { inject } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Entity } from '../../../../definitions/database';
import { EntitiesService } from '../../services/entities.service';

export const entityResolverFn = (
	route: ActivatedRouteSnapshot
): Observable<Entity> => {
	const entitySvc = inject(EntitiesService);
	const entityId = route.paramMap.get('entityId');

	return entityId
		? entitySvc.find(entityId).pipe(catchError(() => of(null)))
		: of(null);
};
